
/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  OrganizationSuggestionsResponse,
  ValidationError,
} from '../models';
import {
    OrganizationSuggestionsResponseFromJSON,
    OrganizationSuggestionsResponseToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface AutocompleteOrganizationRequest {
    q: string;
}

/**
 * 
 */
export class AutocompleteOrganizationApi extends runtime.BaseAPI {

    /**
     * Suggest distinct organizations
          */
    async autocompleteOrganizationRaw(requestParameters: AutocompleteOrganizationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<OrganizationSuggestionsResponse>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling autocompleteOrganization().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<OrganizationSuggestionsResponse>({
            path: `/search/api/autocomplete/organization`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=OrganizationSuggestionsResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Suggest distinct organizations
          */
    async autocompleteOrganization(requestParameters: AutocompleteOrganizationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<OrganizationSuggestionsResponse> {
        const response = await this.autocompleteOrganizationRaw(requestParameters, initOverrides);
        return response._data;
    }

}
